import { createBrowserClient } from '@supabase/ssr';

export function createClient() {
  const supabaseUrl = process.env.NEXT_PUBLIC_SUPABASE_URL;
  const supabaseAnonKey = process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY;

  if (!supabaseUrl || !supabaseAnonKey) {
    console.error('❌ Supabase environment variables are missing!');
    console.error('Please create a .env.local file with:');
    console.error('NEXT_PUBLIC_SUPABASE_URL=your-project-url');
    console.error('NEXT_PUBLIC_SUPABASE_ANON_KEY=your-anon-key');
    console.error('See .env.local.example for reference');

    throw new Error('Supabase credentials not configured. Please set up .env.local file.');
  }

  return createBrowserClient(supabaseUrl, supabaseAnonKey, {
    global: {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
    },
  });
}
